import debounce from 'lodash/debounce'
import * as Types from '../types'

export default
{
	state:
	{
		is_loading: true,
	},

	mutations:
	{
        [Types.IS_LOADING](state)
		{
            state.is_loading = true
        },

        [Types.IS_NOT_LOADING](state)
		{
            state.is_loading = false
        },
	},

	actions:
	{
		[Types.IS_LOADING]: debounce
		(
			({ commit }) =>
			{
				commit({ type: Types.IS_LOADING })
			},
			100
		),

		[Types.IS_NOT_LOADING]: debounce
		(
			({ commit }) =>
			{
				commit({ type: Types.IS_NOT_LOADING })
			},
			100
		),
	},
}